export { BannerWithPaperLayoutRoute, default as BannerWithPaperLayout } from './banner-with-paper-layout';
